import { NavLink, useLocation } from 'react-router-dom';
import { Home, CreditCard, ArrowLeftRight, PiggyBank, Clock, MoreHorizontal } from 'lucide-react';
import { memo } from 'react';

/* Bottom navigation: 6 tabs — regional bank style */
const navItems = [
  { path: '/dashboard',    icon: Home,           label: 'Главная',
    activeMatcher: (loc) => loc.pathname === '/dashboard' || loc.pathname === '/' },
  { path: '/send',         icon: CreditCard,     label: 'Платежи',
    activeMatcher: (loc) => loc.pathname === '/send' || loc.pathname === '/receive' },
  { path: '/exchange',     icon: ArrowLeftRight, label: 'Обмен',
    activeMatcher: (loc) => loc.pathname === '/exchange' },
  { path: '/wallets',      icon: PiggyBank,      label: 'Счета',
    activeMatcher: (loc) => loc.pathname === '/wallets' },
  { path: '/transactions', icon: Clock,          label: 'История',
    activeMatcher: (loc) => loc.pathname === '/transactions' },
  { path: '/more',         icon: MoreHorizontal, label: 'Ещё',
    activeMatcher: (loc) => loc.pathname.startsWith('/more') },
];

export default memo(function MobileBottomNav() {
  const location = useLocation();
  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-white"
      style={{ boxShadow: '0 -2px 12px rgba(26,26,26,0.06)' }}
      data-testid="mobile-bottom-nav"
    >
      <div className="flex items-stretch justify-around h-[64px] px-2 relative">
        {navItems.map((item) => {
          const isActive = item.activeMatcher
            ? item.activeMatcher(location)
            : location.pathname === item.path;
          const Icon = item.icon;
          return (
            <NavLink
              key={item.path}
              to={item.path}
              className="relative flex flex-col items-center justify-center flex-1 gap-0.5 px-0.5 min-w-0 active:scale-95 transition-transform"
              data-testid={`mob-bnav-${item.label.toLowerCase()}`}
            >
              <Icon
                size={20}
                strokeWidth={isActive ? 2.4 : 1.9}
                fill={isActive ? 'currentColor' : 'none'}
                className={isActive ? 'text-brand' : 'text-foreground/45'}
              />
              <span className={`text-[9.5px] font-semibold tracking-tight transition-colors truncate max-w-full ${
                isActive ? 'text-brand' : 'text-foreground/55'
              }`}>{item.label}</span>
            </NavLink>
          );
        })}
      </div>
      {/* Safe-area inset for devices with home indicator */}
      <div className="h-[env(safe-area-inset-bottom)] bg-white" />
    </nav>
  );
});
